<template>
<div >
  <section id="hero_info">
    <article>
      <p class="caption">PDFダウンロード</p>
    </article>
    <div class="attention-logged-in">
      <el-button id="pdf-eprint-edit"
                  type="success"
                  class="button-block"
                  @click="openDownload()">
        <i class="el-icon-printer"></i> ダウンロードする
      </el-button>
      <p class="addition" >※自動でダウンロードされない場合は上の「ダウンロードする」ボタンをクリックしてください。</p>
    </div>
  </section>
</div>
</template>
<style lang="css" src="@/assets/css/renew_info.css"></style>
<script>
export default {
  data: function () {
    return {}
  },
  created : function(){
    console.log('created')
    const urlParams = new URLSearchParams(window.location.search);
    var blob = urlParams.get("blob")
    var filename = urlParams.get("filename")
    let link = document.createElement('a')
    link.href = blob
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  },
  computed: {},
  methods: {
    openDownload: function () {
      const urlParams = new URLSearchParams(window.location.search);
      var blob = urlParams.get("blob")
      var filename = urlParams.get("filename")
      let link = document.createElement('a')
      link.href = blob
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  },
  watch: {},
  mounted: function () {}
}
</script>
